import axios from './configObra/config-obra'

const defaultRoute = '/estoque'

export default {
  converterUnidades: (itens, obra) => {
    return axios.post('/estoque/converterUnidades', { itens, obra })
  },

  encontraEstoquePeloIdDaObra: async (id) => {
    return axios.get(`/estoque/encontraEstoquePeloIdDaObra/${id}`)
  },

  list: (skip, limit, filter, filialId) =>
    axios.get(
      `${defaultRoute}/register-filter/?limit=${limit}&skip=${skip}&${filter}=${filialId}`
    ),
  getOne: async (id) => {
    const { data } = await axios.get(`${defaultRoute}/${id}`)

    return data
  },
  listByDate: (startDate, endDate, obras, filter, filial, reportCode) =>
    axios.post(`${defaultRoute}/busca?${filter}=${filial}`, {
      dataInicio: startDate,
      dataFim: endDate,
      obras: obras,
      reportCode: reportCode,
    }),
  create: (estoque) => axios.post(defaultRoute, estoque),
  update: (id, estoque) => axios.patch(`${defaultRoute}/${id}`, estoque),
  remove: (id) => axios.delete(`${defaultRoute}/${id}`),
  buscaCodigo: (codigo, filter, filial) =>
    axios.get(`${defaultRoute}/busca/${codigo}?${filter}=${filial}`),
  buscaCodigoReq: (codigo, filter, filial, obra) =>
    axios.get(
      `${defaultRoute}/busca/${codigo}?${filter}=${filial}&obra=${obra}`
    ),
  buscaNome: (nome, obra, consulta, filial) => {
    if (consulta) {
      if (filial) {
        return axios.get(`${defaultRoute}/nome`, {
          params: { nome, consulta, filial },
        })
      }
      return axios.get(`${defaultRoute}/nome`, { params: { nome, consulta } })
    } else {
      return axios.get(`${defaultRoute}/nome`, { params: { nome, obra } })
    }
  },
  getLowStock: async (page, filial) => {
    const skip = page

    const data = await axios.get(
      `${defaultRoute}/estoque-baixo-with-pagination`,
      {
        params: { skip, filial },
      }
    )

    return data
  },
}
